import React from 'react';
import {EventAddComponent} from './EventAdd.Component';
import { connect } from "react-redux";
import { httpServices } from '../../../services/httpServices';
import moment from 'moment';

const formValues = {
    'startDate': '',
    'endDate' : '',
    'timeoffTask': '',
    'eventType': '',
    'eventDate':''
}

export class EventAddContainer extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            timeoff_tasks : [],
            id :0,        
            open: false,
            event_types : [],
            formValues: formValues,
            file: {},
            recipients: [],
            custom_recipients_list:[],
            validationErrors: {},
            snackbarOpen : false,
            snackbarMsg : '',
            snackbarVariant : '',
            uploadMaxSize : null,
            postErrors: [],
            event_period : 0,
            action : '',
            doj : '',
            relieved_date : '',
            loader : true,
            infoMessage : '',
            formatedEventPeriod : '',
            eventValidity : true,
        }
        this.getEventFormInputs = this.getEventFormInputs.bind(this); 
        this.handleDateChange = this.handleDateChange.bind(this);
        this.handleOnChange = this.handleOnChange.bind(this);
        this.submitEventRequest = this.submitEventRequest.bind(this);
        this.handleRecipientChange = this.handleRecipientChange.bind(this);
        this.snackbarClose = this.snackbarClose.bind(this);
        this.getRequestDetails = this.getRequestDetails.bind(this);
        this.updateRequest = this.updateRequest.bind(this);
        this.onClose = this.onClose.bind(this);
    }
    componentDidMount = () => {
        if (!this.props.EditId) {
            this.getEventFormInputs();
        }
        else {
            this.getRequestDetails(this.props.EditId);
        }
        if(this.props.Open && this.props.EditId) {
            this.setState({ open: this.props.Open });
            this.getRequestDetails(this.props.EditId);
        }
    };
    
    componentDidUpdate = (prevProps) =>{
        if (this.props.OpenAdd !== this.state.open) {
            this.getEventFormInputs();
            if (!this.props.EditId) {
                this.setState({ open: this.props.OpenAdd, infoMessage : '' });
            }
            else {
                this.setState({ open: this.props.OpenAdd });
            }
        }        
        if (this.props.OpenAdd != prevProps.OpenAdd) {
            this.getEventFormInputs();
            if (!(this.props.EditId > 0)) {
                this.resetFormValues();
            }
            this.setState({ open: this.props.Open });
        }
        if (this.props.EditId !== prevProps.EditId && this.props.EditId > 0) {
            this.getRequestDetails(this.props.EditId);
        }
    };
    
    resetFormValues = () => {
        let formValues = {
            'startDate': '',
            'endDate' : '',
            'timeoffTask': '',
            'eventType': '',
            'eventDate':'',
            'infoMessage' : '',
            'formattedEventPeriod' : ''
        }
        this.setState({ 
            formValues : formValues,
            validationErrors: {}
         });
    }

    getEventFormInputs = () => {
        const apiEndpoint = 'api/request/event/create';
        return httpServices.get(apiEndpoint)
            .then(response => {
                if (response && response.data) {
                    const data = response.data;
                    const userDetails = data.userDetails || {};
    
                    this.setState({
                        timeoff_tasks: data.timeoff_tasks,
                        event_types: data.event_types,
                        recipients: data.recipients,
                        custom_recipients_list: data.custom_recipients_list,
                        uploadMaxSize: data.max_size,
                        doj: userDetails.date_joined || null,
                        relieved_date: userDetails.relieved_date || null,
                        eventValidity : true
                    });
                }
            })
            .catch((error) => {
                console.log("Error:", error);
            });
    };    
        
    handleDateChange = (value, name) => {
        const form_field = this.state.formValues;
        form_field[name] = value;
        if (name == 'eventDate') {    
            form_field['startDate'] = form_field['eventDate'];
            var date = new Date(form_field['eventDate']);
            var period = parseInt(this.state.event_period);
            date.setDate(date.getDate() + (period - 1));
            form_field['endDate'] = moment(date).format('YYYY-MM-DD');
            return httpServices.post('api/request/event/checkEligibility', {'event_date': form_field['eventDate'] ,'end_date':form_field['endDate'], 'doj' : this.state.doj, 'timeoff_type_id': form_field['timeoffTask']})
            .then(response => {           
                if (response.data.changeInDate) { 
                    if (response.data.validEvent) {
                        form_field['startDate'] = response.data.eligibilityPeriodStartDate;
                        this.setState({
                            formValues: form_field,
                            infoMessage : response.data.msg,
                            formattedEventPeriod : response.data.msg ? moment(form_field['startDate']).format('MM/DD/YYYY')+" - "+moment(form_field['endDate']).format('MM/DD/YYYY') : '',
                            eventValidity : response.data.validEvent
                        });
                    }
                    else {
                        this.setState({
                            formValues: form_field,
                            infoMessage : "Based on your joining date, You are not eligible to submit this request",
                            formattedEventPeriod : '',
                            eventValidity : response.data.validEvent
                        });
                    }
                }
                else {
                    this.setState({
                        eventValidity: response.data.validEvent,
                        formValues: form_field,
                        infoMessage: 'Your event eligibility period is :',
                        formattedEventPeriod: moment(form_field['startDate']).format('MM/DD/YYYY')+" - "+moment(form_field['endDate']).format('MM/DD/YYYY'),
                    });
                }

            });
        }
    }
    handleOnChange = (evt, value) => {
        const f = this.state.formValues;
        const name = evt.target.name;
        if (name == "timeoffTask") {
            f['eventDate'] = '';
            let selected_timeoff = evt.target.value;
            Object.keys(this.state.timeoff_tasks).forEach((key) => {
                if (selected_timeoff == this.state.timeoff_tasks[key]['id']) {
                    this.setState({
                        event_period : this.state.timeoff_tasks[key]['event_period'],
                        infoMessage : ''
                    });
                }
            });
            f[name] = evt.target.value;
        }
        else if (name === 'remove_file') { 
            f[name] = evt.target.checked;
                this.setState({
                    file: {},
                });
        } 
        else if (name == "file") {
            let file = evt.target.files[0];
            if (typeof file !== 'undefined') {
                if (file.size > (this.state.uploadMaxSize *1024*1024)) {
                    this.setState({ file : file,
                        postErrors: ["File size exceeded. Maximum allowed size is "+this.state.uploadMaxSize+" MB."] });
                }
                else {
                    this.setState({ file : file,
                        postErrors : [] });
                }
            }
            else {
                this.setState({ file : file,
                    postErrors : [] });
            }
        }
        else {
            f[name] = evt.target.value;
        }
           this.setState({
            formValues: f
        });
    }


    submitEventRequest = () => {
        let data = this.state.formValues;
        console.log(data);
        let valid = this.validateEventDetails(data);
        if (valid) {
            if (this.state.formValues.custom_recipient) {
                let c_recipients = this.state.formValues.custom_recipient;
                data['custom_users'] = JSON.stringify(c_recipients);
            }
            data['file'] = this.state.file;
            return httpServices.post('api/request/event/create', data)
            .then(response => { 
                if (response.data.valid) {
                    this.props.OnClose();
                    this.setState({ open: false,
                        snackbarOpen : true,
                        snackbarMsg : 'Event request created successfully',
                        snackbarVariant : 'success',
                    }, function() {
                        this.props.OnSuccess();
                        this.props.OnParentUpdate();
                    });
                }
                else {
                    this.setState({ 
                        snackbarOpen : true,
                        snackbarMsg : response.data.message,
                        snackbarVariant : 'error'
                    });

                }        
            })
            .catch(function(error) {
                console.log("Error: "+error);
            });
        }
        else {
            return false;
        }
    }
    
    validateEventDetails = () => {
        let errors = {};
        let valid = true;
        let postErrors = '';
        if (this.state.formValues.eventDate == '') {
            valid = false;
            errors['eventDate'] = 'Cannot be empty';
        }
        if (this.state.formValues.endDate > this.state.relieved_date) {
            valid = false;
            postErrors = ["Event request period cannot extend beyond your relieved date"];
        }
        if (this.state.formValues.timeoffTask == '') {
            valid = false;
            errors['timeoffTask'] = 'Cannot be empty';
        }
        this.setState({ validationErrors: errors,
             postErrors : postErrors
        }); 
        return valid;
    }
    
    handleRecipientChange = (evt, value) => {
        let ff = this.state.formValues;
        if (value) {
            if (typeof value === 'object' && value) {
                ff['custom_recipient'] = value;
            }
        }
        this.setState({
            formValues: ff,
        });
    };

    snackbarClose = () => {
        this.setState({
            snackbarOpen : false,
        });
    }
        
    getRequestDetails = (editId) => {
        let apiEndpoint = 'api/request/event/edit';
        return httpServices.post(apiEndpoint, {editId: editId})
            .then(response => {
                if (response) {
                    let formValues = {};
                    let tempFormValues = response.data.request_details;
                    let removeFile = tempFormValues.name ? false : true; 
                    formValues = {
                            startDate: tempFormValues.start_date,
                            endDate: tempFormValues.end_date,
                            timeoffTask: tempFormValues.task_id,
                            eventType : tempFormValues.request_event_type,
                            file_name: tempFormValues.name ? tempFormValues.name : null,
                            remove_file: removeFile,
                            attachment_id: tempFormValues.attachment_id,
                            custom_recipient : response.data.custom_users ? response.data.custom_users : null,
                            eventDate : tempFormValues.event_date
                        };
                    this.setState({
                        timeoff_tasks: response.data.timeoff_tasks,
                        event_types : response.data.event_types,
                        recipients : response.data.recipients,
                        custom_recipients_list : response.data.custom_recipients_list,
                        uploadMaxSize : response.data.max_size,
                        formValues : formValues,
                        action : 'edit',
                        event_period : tempFormValues.event_period,
                        infoMessage : tempFormValues.info_msg ? tempFormValues.info_msg : '',
                        formattedEventPeriod : tempFormValues.formatted_event_period ? tempFormValues.formatted_event_period : '',
                    } , function() {
                        this.props.OnSuccess();
                    });
                }
            })
            .catch(function (error) {
                console.log("Error: " + error);
            });
    
    }
    updateRequest = () => {
        let data = this.state.formValues;
        data['editId']  = this.props.EditId;
        data['attachment'] = this.state.file;
        data['attachment_id'] = this.state.formValues.attachment_id;
        data['remove_file'] = this.state.formValues.remove_file;
        if (this.state.formValues.custom_recipient) {
            let c_recipients = this.state.formValues.custom_recipient;
            data['custom_users'] = JSON.stringify(c_recipients);
        }
        let valid = this.validateEventDetails(data);
        if (this.state.formValues.custom_recipient) {
            let c_recipients = this.state.formValues.custom_recipient;
            data['custom_users'] = JSON.stringify(c_recipients);
        }
        if (valid) {
            data['action'] = 'update';
             return httpServices.post('api/request/event/edit', data)
            .then(response => { 
                if (response.data.valid) {
                    this.setState({ open: false,
                        snackbarOpen : true,
                        snackbarMsg : 'Event request updated successfully',
                        snackbarVariant : 'success'
                    }, function ()  {
                        this.props.OnClose();
                        this.props.OnParentUpdate();
                    } 
                        );
                }
                else {
                    this.setState({ 
                        snackbarOpen : true,
                        snackbarMsg : response.data.message,
                        snackbarVariant : 'error'
                    });

                }       
            })
            .catch(function(error) {
                console.log("Error: "+error);
            });
        }
        else {
            return false;
        }

    }
    
    onClose = () => {
        this.setState({
                open : false,
                loader:  false,
                eventValidity: true
            });
    }
 
    render() {
        return (
            <EventAddComponent
                Open = { this.state.open }
                OnClose = {this.props.OnClose } 
                TimeoffTasks = { this.state.timeoff_tasks }
                EventTypes = { this.state.event_types }
                HandleDateChange = { this.handleDateChange }
                FormValues = {this.state.formValues}
                HandleOnChange = { this.handleOnChange }
                SubmitEventRequest = { this.submitEventRequest }
                Recipients = { this.state.recipients }
                HandleRecipientChange={this.handleRecipientChange}
                Custom_recipients_list = { this.state.custom_recipients_list }
                ValidationErrors = { this.state.validationErrors }
                SnackbarOpen = {this.state.snackbarOpen}
                SnackbarMsg = {this.state.snackbarMsg}
                SnackbarVariant = {this.state.snackbarVariant}
                SnackbarClose = {this.snackbarClose}
                ErrorsArray = { this.state.postErrors }
                EditId = {this.props.EditId }
                Title = { this.props.Title }
                UpdateRequest = { this.updateRequest }
                Action = { this.state.action }
                DOJ = { this.state.doj }
                RelievedDate = { this.state.relieved_date }
                Loader = { this.state.loader }
                InfoMessage = { this.state.infoMessage }
                FormattedEventPeriod = {this.state.formattedEventPeriod }
                EventValidity = { this.state.eventValidity }
            />
        )
    }
}
